import { FormActionContext } from "@lhd/features/Apps/AppForm";
import { Input, InputRef, Tooltip, Typography } from "antd";
import { DebouncedFunc } from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

interface IProps {
  defaultValue?: string;
  name: string;
  handleChange: DebouncedFunc<
    (appId: string, type: string, value: string, isEdit?: boolean) => void
  >;
  appId: string;
  width: number;
}
const InputEdit = (props: IProps) => {
  const { defaultValue, handleChange, appId, name, width } = props;
  const { contextState } = useContext(FormActionContext);
  const [isOver, setIsOver] = useState(false);
  const isError = contextState.isError;
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    if (textRef.current) {
      const isOver = textRef.current.offsetWidth < textRef.current.scrollWidth;
      setIsOver(isOver);
    }
  }, [defaultValue, width, textRef.current]);

  if (!isEditing) {
    const content = (
      <div
        ref={textRef}
        onDoubleClick={() => {
          setIsEditing(!isError);
        }}
        style={{
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {defaultValue}
      </div>
    );
    return isOver ? (
      <Tooltip placement="top" title={defaultValue}>
        {content}
      </Tooltip>
    ) : (
      content
    );
  }

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <Input
        ref={inputRef}
        className="input_edit"
        required
        size="small"
        {...(isError && { status: "error" })}
        defaultValue={defaultValue}
        onChange={(e) => {
          handleChange(appId, name, e.target.value, true);
        }}
        onKeyDown={(e) => {
          if (!isError && e.key === "Enter") {
            setIsEditing(isError);
          }
        }}
        suffix={
          <AiOutlineClose
            onClick={() => setIsEditing(isError)} // if isError = true => can turn off editing = false
            style={{ color: "rgba(0,0,0,.45)" }}
          />
        }
        onBlur={() => {
          setIsEditing(isError);
        }}
      />
      {isError && (
        <Typography.Text
          type="danger"
          style={{
            fontSize: 14,
            position: "absolute",
            // bottom: typeField == "name" ? 3 : -6,
            right: 25,
            zIndex: 10,
          }}
        >
          必須
        </Typography.Text>
      )}
    </div>
  );
};

export default InputEdit;
